import Vue from "vue";
import Router from "vue-router";
import caseBox from  '../views/case-box.vue'
Vue.use(Router);
//解决多次跳转的报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home", //首页
    component: () => import("../views/index.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/plantSolution", //智慧工厂解决方案
    component: () => import("../views/solution.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/productCenter", //产品中心
    component: () => import("../views/product-center.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/gardenSolution", //智慧园区解决方案
    component: () => import("../views/garden-solution.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/logisticsSolution", //智慧物流解决方案
    component: () => import("../views/logistics-solution.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: `/succeedCase`, //成功案例
    redirect: "/succeedCase/AllCase",
    component: () => import("../views/succeed-case.vue"),
    meta: { scrollTrue: true },
    children: [
      {
        path: "/succeedCase/AllCase", //每个成功案例
        component: () => import("../views/case-box.vue")
      }
    ]
  },
  {
    path: "/caseDetails", //案例详情
    component: () => import("../views/case-details.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/serviceSupport", //服务与支持
    name: "serviceSupport",
    component: () => import("../views/service-support.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/aboutUs", //关于我们
    component: () => import("../views/about-us.vue"),
    redirect: "/aboutUs/chairman",
    meta: { scrollTrue: true },

    children: [
      {
        path: "electricity", //公司介绍
        component: () => import("../components/common/about-us/introduce.vue")
      },
      {
        path: "development", //发展历程
        component: () => import("../components/common/about-us/development.vue")
      },
      {
        path: "certification", //资质荣誉
        component: () =>
          import("../components/common/about-us/certification.vue")
      },
      {
        path: "responsibility", //社会责任
        component: () =>
          import("../components/common/about-us/responsibility.vue")
      },
      {
        path: "culture", //企业文化
        component: () => import("../components/common/about-us/culture.vue")
      },
      {
        path: "chairman", //董事长致辞
        component: () => import("../components/common/about-us/chairman.vue")
      },
      {
        path: "journalism", //新闻中心
        component: () => import("../components/common/about-us/journalism.vue")
      },
      {
        path: "contactUs", //联系我们
        component: () => import("../components/common/about-us/contact-us.vue")
      },
      {
        path: "videoDetails", //视频中心
        component: () =>
          import("../components/common/about-us/video-details.vue"),
        meta: { scrollTrue: true }
      },
      {
        path: "downloadCenter", //视频中心
        component: () =>
          import("../components/common/about-us/download-center.vue"),
        meta: { scrollTrue: true }
      }
    ]
  },
  {
    path: "/AGVDetails", //硬件AGV
    component: () => import("../views/agv-details.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/pilerDetails", //硬件堆垛机
    component: () => import("../views/piler.vue"),
    meta: { scrollTrue: true }
  },

  {
    path: "/joinUs", //加入我们
    component: () => import("../views/join-us.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/joinUsDetails", //招聘详情页
    component: () => import("../views/join-details.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/stockmarket", //投资者关系股票行情
    component: () => import("../views/investor.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/secretaries", //投资者关系董秘邮箱
    component: () => import("../views/secretaries.vue"),
    meta: { scrollTrue: true }
  },
  {
    path: "/investorNews", //投资者关系定期报告
    component: () => import("../views/investor-news.vue"),
    meta: { scrollTrue: true }
  }
];

var router = new Router({
  mode: "history",
  routes
});
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  if (to.meta.scrollTrue && !to.query.anchor) {
    let timer = null;
    cancelAnimationFrame(timer);
    timer = requestAnimationFrame(function fn() {
      var oTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (oTop > 0) {
        document.body.scrollTop = document.documentElement.scrollTop =
          oTop - 100;
        timer = requestAnimationFrame(fn);
      } else {
        cancelAnimationFrame(timer);
      }
    });
  }
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", to.fullPath]);
    }
  }
  // if(sessionStorage.getItem("path")&&sessionStorage.getItem("pathTrue")=='true') {
  //   let data = JSON.parse(sessionStorage.getItem("path"))
  //   data.forEach(item => {
  //     console.log(item)
  //     let rou = {
  //       path:item.path,
  //       component:caseBox
  //     }
  //     router.options.routes.forEach(item1=>{
  //       if(item1.path=='/succeedCase') {
  //         item1.children.push(rou)
  //       }
  //     })
  //     // router.addRoute(rou)
  //   });
  //   sessionStorage.setItem("pathTrue",'false')
  // }
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js